<template>
  <div class="box9-page">
    <div class="page-title">
      <h2>不讲正确的废话<br/>每个知识点都落地成可执行的操作</h2>
      <p>保证看了就会 ，会了还能操作，操作了就有效果！</p>
    </div>
    <div class="page-content">
      <div class="cont-box">
        <div class="cont-title">
          <img src="../../../assets/coursePage/newMedia2/box9/icon-fire.png" alt="">
          <span>赛道</span>
        </div>
        <ul class="list-1">
          <li v-for="(item, index) in list1" :key="index">{{ item }}</li>
        </ul>
      </div>
      <div class="cont-box">
        <div class="cont-title">
          <img src="../../../assets/coursePage/newMedia2/box9/icon-card.png" alt="">
          <span>内容类别</span>
        </div>
        <ul class="list-2">
          <li v-for="(item, index) in list2" :key="index">
            <img :src="require(`../../../assets/coursePage/newMedia2/box9/icon-type-${index + 1}.png`)" alt="">
            <span> {{ item }}</span>
          </li>
        </ul>
      </div>
      <div class="cont-box">
        <div class="cont-title">
          <img src="../../../assets/coursePage/newMedia2/box9/icon-lipstick.png" alt="">
          <span>美妆</span>
        </div>
        <ul class="list-3">
          <li v-for="(item, index) in list3" :key="index">
            <div class="item-cont">
              <div class="item-title">
                <img :src="require(`../../../assets/coursePage/newMedia2/box9/icon-type-${index + 1}.png`)" alt="">
                <span>{{ item.stit }}</span>
              </div>
              <div class="item-info">
                <span>{{ item.text1 }}</span>
                <span>{{ item.text2 }}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="prompt-copy"></div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        list1:[
          '美妆', '时尚穿搭', '运动健身', '美食', '母婴亲子', '教育培训', '家具家装', '萌宠', '财经投资', '科技数码', '三农', '珠宝文化',
        ],
        list2:[
          '真实过程', '搞笑演绎', '有用知识', '扎心故事', '爆品宣销', '采访记录'
        ],
        list3: [
          {
            text1: '记录自己化妆的过程',
            text2: '记录自己护肤的过程',
            stit: '真实过程'
          },
          {
            text1: '美妆店剧情',
            text2: '职场美妆剧情',
            stit: '搞笑演绎'
          },
          {
            text1: '不脱妆的10个小技巧',
            text2: '10个化妆冷知识',
            stit: '有用知识'
          },
          {
            text1: '一次不美丽的美容院经历',
            text2: '因为妆容职场出现的乌龙事件',
            stit: '扎心故事'
          },
          {
            text1: '推荐一款定妆喷雾',
            text2: '面霜推荐',
            stit: '爆品宣销'
          },
          {
            text1: '化妆为什么会脱妆',
            text2: '最近购买最满意的美妆产品',
            stit: '采访记录'
          }
        ],
      }
    }
  }
</script>

<style lang="scss" scoped>
.box9-page{
  padding: 80px 0;
  background-image: url(../../../assets/coursePage/newMedia2/box9/box9-bg.png);
  background-size: cover;
  margin-bottom: 300px;
  position: relative;

  .page-content{
    width: 690px;
    margin: 0 auto;
    padding-top: 20px;
    .cont-box{
      background-color: #ffffff;
      box-shadow: 0px 0px 30px 0px 
        rgba(229, 184, 199, 0.4);
      border-radius: 20px;
      margin-top: 30px;
      padding: 40px 30px 30px;
      .cont-title{
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        img{
          width: 40px;
          height: 40px;
        } 
        span{
          margin-left: 20px;
          font-family: PingFang-SC-Bold;
          font-size: 30px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 0px;
          color: #4d1f2e;
        }
      }

      &:nth-of-type(1){
        padding-bottom: 0;
        .list-1{
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap:wrap;
          li{
            width: 190px;
            height: 48px;
            background-color: #ffe5f6;
            border: 1px solid #ff3377;
            border-image-slice: 1;
            font-family: PingFang-SC-Medium;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #33141f;
            margin-bottom: 30px;
            border-radius: 10px;
            text-align: center;
            line-height: 48px;;
          }
        }
      }
      &:nth-of-type(2){
        .list-2{
          height: 150px;
          background-color: #ffe5f6;
          border-radius: 12px;
          border: solid 1px #ff6699;
          padding: 30px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap:wrap;
          li{
            display: flex;
            align-items: center;
            img{
              width: 32px;
              height: 32px;
              margin-right: 10px;
            }
            span{
              font-size: 24px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 32px;
              letter-spacing: 1px;
              color: #33141f;
            }
            &:nth-of-type(1),
            &:nth-of-type(2),
            &:nth-of-type(3){
              margin-bottom: 28px;
            }
          }
        }
      }
      &:nth-of-type(3){
        .list-3{
          li{
            background-color: #ffe5f6;
            border-radius: 20px;
            padding: 5px;
            margin-bottom: 20px;
            &:last-child{
              margin: 0;
            }
            .item-cont{
              background-color: #ffffff;
              border-radius: 16px;
              border: solid 1px #ff99bb;
              padding: 32px 27px;
              box-sizing: border-box;
              .item-title{
                display: flex;
                align-items: center;
                img{
                  width: 32px;
                  height: 32px;
                  margin-right: 12px;
                }
                span{
                  font-family: PingFang-SC-Bold;
                  font-size: 27px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 32px;
                  letter-spacing: 1px;
                  color: #33141f;
                }
              }
              .item-info{
                margin-top: 18px;
                padding-left: 44px;
                span{
                  display: inline-block;
                  padding-left: 13px;
                  position: relative;
                  font-family: PingFang-SC-Regular;
                  font-size: 24px;
                  font-weight: normal;
                  font-stretch: normal;
                  line-height: 24px;
                  letter-spacing: 0px;
                  color: #253326;
                  &:first-child{
                    width: 270px;
                  }
                  &::after{
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    content: "";
                    width: 6px;
                    height: 6px;
                    background-color: #ff3377;
                  }
                }
              }
            }
            &:nth-of-type(4),
            &:nth-of-type(6){
              .item-info{
                span{
                  display: block;
                }
                span:last-child{
                  margin-top: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
  .prompt-copy{
    width: 100%;
    height: 300px;
    position: absolute;
    bottom: -300px;
    left: 0;
    background-image: url(../../../assets/coursePage/newMedia2/box9/pic-text.png);
    background-size: 100% 100%;
  }

}
</style>